import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';

export const IconPlayButton = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    data-slot="icon-play-button"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    fill="none"
    className={clsxm('text-destructive size-16', className)}
    {...props}
  >
    <circle cx="31.9984" cy="31.9999" r="25.6" fill="currentColor" />
    <path d="M40 32L28 38.9282L28 25.0718L40 32Z" className="fill-foreground-inverted" />
  </svg>
);
